module.exports = __webpack_public_path__ + "img/anx_anoxanoxanox.47447da.png";